<template>
  <div class="grid">
		<div class="col-12">
            <div class="card">
                <Toast/>
                <Error :errors="errors"/>

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter"/>
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number" @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{width:'20px'}" >
                        <template #body="slotProps">
                        {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="username" header="Username">
                        <template #body="slotProps">
                            {{slotProps.data.username}}
                        </template>
                    </Column>
                    <Column field="nama" header="Name">
                        <template #body="slotProps">
                            {{slotProps.data.nama}}
                        </template>
                    </Column>
                    <Column field="cust_account_type" header="Account Type">
                        <template #body="slotProps">
                            {{slotProps.data.cust_account_type}}
                        </template>
                    </Column>
                    <Column field="cust_location_name" header="Venue">
                        <template #body="slotProps">
                            {{slotProps.data.cust_location_name}}
                        </template>
                    </Column>
                    <Column field="bcvisit_customer" header="Customer Name">
                        <template #body="slotProps">
                            {{slotProps.data.bcvisit_customer}}
                        </template>
                    </Column>
                    <Column field="bcvisit_phone" header="Customer Phone">
                        <template #body="slotProps">
                            {{slotProps.data.bcvisit_phone}}
                        </template>
                    </Column>
                    <Column field="product_name" header="Product">
                        <template #body="slotProps">
                            {{slotProps.data.product_name}}
                        </template>
                    </Column>
                    <Column field="sales_qty" header="Sales Qty">
                        <template #body="slotProps">
                            {{slotProps.data.sales_qty}}
                        </template>
                    </Column>
                    <Column field="sales_price" header="Sales Price" :style="{ 'text-align': 'right' }">
                        <template #body="slotProps">
                            {{ formatCurrency(slotProps.data.sales_price) }}
                        </template>
                    </Column>
                    <Column field="sales_value" header="Sales Value" :style="{ 'text-align': 'right' }">
                        <template #body="slotProps">
                            {{ formatCurrency(slotProps.data.sales_value) }}
                        </template>
                    </Column>
                    <Column field="sampling_bottle" header="Sampling (Bottle)">
                        <template #body="slotProps">
                            {{slotProps.data.sampling_bottle}}
                        </template>
                    </Column>
                    <Column field="sampling_cup" header="Sampling (Cup)">
                        <template #body="slotProps">
                            {{slotProps.data.sampling_cup}}
                        </template>
                    </Column>
                    <Column field="stok_produk_awal" header="Stok Produk Awal">
                        <template #body="slotProps">
                            {{slotProps.data.stok_produk_awal}}
                        </template>
                    </Column>
                    <Column field="gimmick_name" header="Gimmick">
                        <template #body="slotProps">
                            {{slotProps.data.gimmick_name}}
                        </template>
                    </Column>
                    <Column field="gimmick_qty" header="Gimmick Qty">
                        <template #body="slotProps">
                            {{slotProps.data.gimmick_qty}}
                        </template>
                    </Column>
                    <Column field="created_at" header="Created At">
                        <template #body="slotProps">
                            {{ formatDate(slotProps.data.created_at) }}
                        </template>
                    </Column>
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]">
                    <template>
                        {{totalItemsCount}}
                    </template>
                </Paginator>
            </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';
import Filter from '../../components/report/bacardi-sales/Filter.vue';
import Error from '../../components/Error.vue';

export default {
    components: {
		'Filter': Filter,
		'Error': Error,
	},
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        }
    },
    computed:{
        ...mapGetters(['errors']),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        formatCurrency(value) {
            if (!value) return '';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        // Fungsi untuk membungkus teks setiap 20 huruf
        wrapTextByLetters(text, charLimit) {
            if (!text) return '';
            let result = '';
            
            for (let i = 0; i < text.length; i++) {
                result += text[i];
                // Tambahkan tag <br> setelah mencapai batas huruf
                if ((i + 1) % charLimit === 0) {
                    result += '<br>';
                }
            }
            return result.trim();
        },
        // DATATABLE
        getDataTable(){
          
            this.loading=true;
            this.$refs.filter.loading = true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/bacardi-sales',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                    "product_id" : this.$refs.filter.product,
                    "start_date" : this.$refs.filter.period_start_label,
                    "end_date" : this.$refs.filter.period_end_label,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
              this.$refs.filter.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading=false;
                this.$refs.filter.loading = false;
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext){

            if(
              this.$refs.filter.period_start_label !== null && 
              this.$refs.filter.period_end_label !== null && 
              this.$refs.filter.period_start_label !== 'Invalid date' && 
              this.$refs.filter.period_end_label !== 'Invalid date'
            ){  

                if(ext == 'xlsx'){
                    this.loadingExcel=true;
                }else if(ext == 'csv'){
                    this.loadingCsv=true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/bacardi-sales/export',
                    responseType: 'blob',
                    params: {
                        "ext" : ext,
                        "product_id" : this.$refs.filter.product,
                        "start_date" : this.$refs.filter.period_start_label,
                        "end_date" : this.$refs.filter.period_end_label,
                    }
                })
                .then(response => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement('a');

                    fileLink.href = fileUrl;

                    fileLink.setAttribute('download', 'Report Bacardi Sales Export.' + ext);
                    
                    document.body.appendChild(fileLink)

                    fileLink.click();
                    
                    if(ext == 'xlsx'){
                        this.loadingExcel=false;
                    }else if(ext == 'csv'){
                        this.loadingCsv=false;
                    }

                })
                .catch((err) => {
                    console.log(err);
                    
                    if(ext == 'xlsx'){
                        this.loadingExcel=false;
                    }else if(ext == 'csv'){
                        this.loadingCsv=false;
                    }
                });

            }else{
                 alert('Pastikan rentang waktu sudah benar atau tidak kosong');
            }
        },
    }
}
</script>
